import React from 'react';
import { InputAdornment, IconButton, makeStyles } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { BaseInput } from '../form/BaseInput';
import { theme } from 'src/components/theme';

const useStyles = makeStyles((theme) => ({
  searchField: {
    width: '100%',
    '& .MuiInputBase-input': {
      padding: '9.5px 10px',
      [theme.breakpoints.up('sm')]: {
        width: '300px',
        marginRight: '0px',
      },
    },
  },
}));

interface PointsSearchProps {
  searchTerm: string;
  onSearch: (value: string) => void;
  onClear: () => void;
}

const PointsSearch: React.FC<PointsSearchProps> = ({ searchTerm, onSearch, onClear }) => {
  const classes = useStyles(theme);

  return (
    <BaseInput
      className={classes.searchField}
      size="small"
      label="Search points"
      variant="outlined"
      value={searchTerm}
      onChange={(e) => onSearch(e.target.value)}
      placeholder="Search by description or name..."
      InputProps={{
        endAdornment: searchTerm && (
          <InputAdornment position="end">
            <IconButton size="small" onClick={onClear}>
              <ClearIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default PointsSearch;
